export const faqsOptions = [
    {
        question: 'Why should i choose QuickRemit?',
        answer: `
            <div>
                <p>At QuickRemit, your happiness and satisfaction are paramount to us. We provide you with a customised service tailored specifically to your needs and requirements.</p>
                <p>we utilise our wide networks, experts &nbsp;and market knowledge to get you the most competitive exchange rates in the market thereby saving you money on your transfers.&nbsp;</p>
            </div>
        `,
    },
    {
        question: 'Who is QuickRemit?',
        answer: `
            <div>
                QuickRemit is a secure and easy-to-use, online and Mobile App money transfer service which enables you to send money using your debit or by bank transfer.
            </div>
        `
    },
    {
        question: 'What services does QuickRemit Provide?',
        answer: `
            <div>
                Bank account deposit Transfer-you can transfer money direct into local currency account
            </div>
        `,
    },
    {
        question: 'Where can I send money with QuickRemit?',
        answer: `
            <div>We provided a remittance service globally.</div>
        `,
    },
    {
        question: 'What are the benefits of sending money using QuickRemit?',
        answer: `
            <div>
                <p><strong>The key benefits of the QuickRemit Service are: </strong></p>
                <p>Speed, Convenience, best exchange rate and low fees &ndash; because the service is available online and via the mobile App, you can send money without having to visit a bank branch. Hassle free.</p>
            </div>
        `,
    },
    {
        question: 'What do I need to enable me to use QuickRemit Online?',
        answer: `
            <div>
                <ol>
                    <li>
                        <p>You need an email address and mobile number:&nbsp;</p>
                    </li>
                    <li>
                        <p>Password- For new customers you will have to create your own password during registration. For existing customers this will be generated by the system uniquely for you. You can however change it to something you can easily remember.</p>
                    </li>
                    <li>
                        <p>Contact address information</p>
                    </li>
                    <li>
                        <p>Date of birth</p>
                    </li>
                </ol>
                <p>Note: For your first money transfer, you will be required to register before you can login to send money using QuickRemit</p>
            </div>
        `,
    },
    {
        question: 'How do I signup on  the QuickRemit platform?',
        answer: `
            <div>
                <p>You can sign up to QuickRemit Service by following the steps outlined below:</p>
                <ul>
                    <li>
                        <p>New User Registration&nbsp;</p>
                    </li>
                    <li>
                        <p>Fill in all mandatory fields marked **,</p>
                    </li>
                    <li>
                        <p>Step 1: Click on the &lsquo;Sign up&rsquo; button.</p>
                    </li>
                    <li>
                        <p>Step 2: Fill in your personal details/contact details and password,</p>
                    </li>
                    <li>
                        <p>Step 3: Follow the on-screen instructions to complete your registration</p>
                    </li>
                </ul>
            </div>
        `,
    },
    {
        question: 'How do I send money online using QuickRemit?',
        answer: `
            <div>
                <p>QuickRemit has made sending money easier, faster and safer for your complete peace of mind. Follow the simple steps below after successful registration:.</p>
                <ul>
                    <li>
                        <p>Login using your username and password</p>
                    </li>
                    <li>
                        <p>Create a new beneficiary or select your existing beneficiary from the list.</p>
                    </li>
                    <li>
                        <p>Follow the on-screen instructions to complete your transaction</p>
                    </li>
                </ul>
                <p>When a transaction is completed successfully you should find the Reference to share with your Receiver.</p>
            </div>
        `,
    },
    {
        question: 'Can I send money into a beneficiary’s bank account?',
        answer: `<div>
            Yes, all you need is beneficiary account number and bank name.
        </div>`,
    },
    {
        question: 'What are QuickRemit fees & charges?',
        answer: `
            <div>
                <p>You will be informed of the transfer charges for sending money using QuickRemit before you confirm any transfer and the exchange rate used to derive the estimated amount that your beneficiary will receive in the designated currency before you proceed to confirm and save your transaction.</p>
                <p>You can also find the charges by visiting our website and entering the amount you want to send into our easy to use currency calculator.</p>
            </div>
        `,
    },
    {
        question: 'How much money can I send using QuickRemit?',
        answer: `<p>You can send as much as you can subject to our compliance requirements.</p>`,
    },
    {
        question: 'How long will it take for the money to reach the beneficiary?',
        answer: `<div>Within 30 minutes for straight transfer to bank account.</div>`,
    },
    {
        question: 'How can I track if the money has been sent to the beneficiary?',
        answer: `<div>Both parties will get payment Alert – notification once beneficiary receives payment</div>`,
    },
    {
        question: 'How long does a cancellation take?',
        answer: `<div>Transactions are usually cancelled within 24 hours upon request.</div>`,
    },
    {
        question: 'How long does a refund take?',
        answer: `<div>Once the transaction has been cancelled and we have confirmed this to you then a refund usually takes 5 full working days to be credited back to you. e.g. If you request a cancellation on a Monday, you would usually have the funds back in your account by Thursday.</div>`,
    },
    {
        question: 'Can I cancel a transaction myself?',
        answer: `<div>Senders can cancel a transaction within 5 minutes from when the transaction is concluded.</div>`,
    },
    {
        question: 'How can I request a refund?',
        answer: `<div>We can only refund a transaction which has not been paid out. All requests for refunds must be sent to <a href="mailto:support@quickremitltd.com">support@quickremitltd.com</a> quoting the Transaction ID, Reference Number, Amount involved</div>`,
    },
    {
        question: 'Is there a limit on the number of beneficiaries that I can send money to?',
        answer: `<div>No. You can send money to as many people as you wish. But there is a limit to the amount of money you can send in a day – limit as set above.</div>`,
    },
    {
        question: 'What do I do if I forget my QuickRemit Account Password?',
        answer: `<div>A ‘Forget Password’ link is displayed on the Login page. Client will click on it and input the registered email address, instructions on resetting the password will be sent to that email address if it is on file.</div>`,
    },
    {
        question: 'What are the terms and conditions for using the QuickRemit?',
        answer: `<p><a href="https://www.quickremitltd.com/terms-conditions/" style="text-decoration:none;"><span style="font-size:11pt;font-family:Calibri,sans-serif;color:#0000ff;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">https://www.quickremitltd.com/terms-conditions/</span></a></p>`,
    },
    {
        question: 'How do I find out more about QuickRemit?',
        answer: `<p>Visit our website: <a href="https://www.quickremitltd.com/" rel="noopener noreferrer" target="_blank">https://www.quickremitltd.com/</a></p>`,
    },
    {
        question: 'Why does QuickRemit need to verify me?',
        answer: `
            <div>
                <p><span>As a Financial Service company regulated by the Financial Conduct Authority, we are required by law to verify all our customers we do business with.</span><span><br></span><span>We will need to verify your name, address and date of birth. In order to do this we may require &nbsp;your photo ID and a proof of address.</span><span><br></span><span>In addition, we may also from time to time request information in relation to the purpose of your transfer and/or request evidence to confirm the source of the funds being sent.</span><span><br></span><span>We will contact you if we require anything from you, so please ensure you check your emails regularly after you&rsquo;ve successfully registered and created a transfer.</span></p>
                <p><span><span>You can scan and upload your ID securely at any time once you log into your QuickRemit account or you can email the relevant document to our Customer Service team, support@quickremitltd.com</span></span></p>
            </div>
        `,
    },
    {
        question: 'Is there anything I need to know before I upload my ID?',
        answer: `
            <div>
                <p>When submitting your ID, please ensure that it is a &nbsp;high-quality photo or scan showing:</p>
                <p>&bull; Your photo</p>
                <p>&bull; Your full name</p>
                <p>&bull; Your date of birth</p>
                <p>&bull; Your signature</p>
                <p>&bull; An expiry date</p>
                <p>&bull; The place of issue</p>
                <p>&bull; Document number</p>
                <p>The full name and date of birth must match the details on your QuickRemit account.</p>
            </div>
        `,
    },
    {
        question: 'What types of ID will QuickRemit Accept?',
        answer: `
            <div>
                <p>ID documents we accept include:</p>
                <p>&bull; Valid Passport</p>
                <p>&bull; Valid European National ID card</p>
                <p>&bull; Valid UK Full Photo driving licence</p>
                <p>&bull; UK Biometric Residence Card with at least 6 months validity</p>
                <p>If you are providing an ID card or Full driving licence, we will need to see both the front and back of the card. If your document is not accepted, it could be for many reasons. These can include:</p>
                <p>&bull; The quality of the photograph / scan</p>
                <p>o There may be glare / light reflection that obscures the image</p>
                <p>o The image may be too low resolution to read</p>
                <p>o The image may have been cropped so all the details are not visible</p>
                <p>&bull; The expiry date</p>
                <p>o The ID may have expired. We can only accept valid in date IDs</p>
                <p>&bull; The details on your ID</p>
                <p>o The details (including name and date of birth) on the ID provided must match your QuickRemit account</p>
                <p>&bull; The ID type</p>
                <p>o The types of document we can accept are government issued.</p>
            </div>
        `,
    },
    {
        question: 'What is Address Verification?',
        answer: `
            <div>
                <p>As a Financial Service company regulated by the Financial Conduct Authority we are required by law to verify all our customers we do business with and part of this process involve address verification.</p>
                <p>You can scan and upload your proof address (which must not be more than 3-months old) when you register/log into your QuickRemit account or alternatively emailing the relevant document to our Customer Service team support@quickremitltd.com</p>
                <p>When submitting your proof of address, please ensure that it is a colour high-quality document or scan of a valid document showing:</p>
                <p>&bull; Your full name</p>
                <p>o This must match what appears on your QuickRemit account</p>
                <p>&bull; Your full home address</p>
                <p>o This cannot be an office /workplace address</p>
                <p>o This must match what appears on your QuickRemit account</p>
                <p>&bull; The date of issue</p>
                <p>o This should not be more than 3 months old</p>
                <p>&bull; A logo or clear name of the sender</p>
                <p>o This should appear on all official bills or statements as a letterhead</p>
                <p>The name and address on the document must match the details on your QuickRemit account.</p>
            </div>
        `,
    },
    {
        question: 'What types of document can you accept for address verification?',
        answer: `
            <div>
                <p>Proof of address documents we will accept are as follows:</p>
                <p>&bull; Utility Bill</p>
                <p>o This can be gas, electricity, water or insurance bills.</p>
                <p>o We do not accept mobile phone bills</p>
                <p>o This must be no older than 3 months</p>
                <p>&bull; Full UK Photocard Driving Licence</p>
                <p>o This must show your address</p>
                <p>o This must be in date &ndash; we do not accept expired documents</p>
                <p>&bull; Bank / Credit card statement</p>
                <p>o This must be no older than 3 months</p>
                <p>If your document is not accepted, it could be for any of these reasons.</p>
                <p>&bull; The date</p>
                <p>o If the document is older than 3 months so we cannot accept</p>
                <p>&bull; The details on your document</p>
                <p>o The details (including name and address) on the document provided must match your QuickRemit account details</p>
                <p>o The details must be for your home residence, not a PO Box or workplace</p>
                <p>&bull; The document type</p>
                <p>The type of document may not be one we can accept</p>
                <p><br></p>
            </div>
        `,
    },
    {
        question: 'What happens to my personal information after I upload it?',
        answer: `
            <div>
                <p>As a Financial Service company regulated by the Financial Conduct Authority, QuickRemit are required by law to keep your personal information securely and not to share with any third party without your concern. Your information and/or documents are stored on our secured servers.</p>
                <p>You can read more about our privacy policy and how we use your information here: <a href="https://www.quickremitltd.com/privacy-policy/" rel="noopener noreferrer" target="_blank">https://www.quickremitltd.com/privacy-policy/</a></p>
                <p><br></p>
            </div>
        `,
    },
    {
        question: 'How do I change the name on my account?',
        answer: `
            <div>
                <p>The name on your QuickRemit account must be your full legal name that appears on your valid ID.</p>
                <p>If you have made a mistake when registering (for example you may have misspelt your name), or if you have changed your name please contact our customer service by emailing support@quickremitltd.com to get help.</p>
                <p>Alternatively a profile update form is available on the portal for clients to change their details and attach supporting documentation.</p>
                <p>Changes will need to be verified and approved before it can be reflected.</p>
            </div>
        `,
    },
    {
        question: 'How do I change the date of birth on my account?',
        answer: `
            <div>
                <p>The date of birth on your QuickRemit account must be your real date of birth that appears on your birth certificate or valid ID.</p>
                <p>If you have made a mistake when registering (for example you may have mistyped your date of birth), please contact customer service by emailing support@quickremitltd.com to get help.</p>
                <p>Alternatively, a profile update form is available on the portal for clients to change their details and attach supporting documentation. Changes will need to be verified and approved before it can be reflected</p>
            </div>
        `,
    },
    {
        question: 'How do I change the address on my account?',
        answer: `
            <div>
                <p>The address on your QuickRemit account must be your full current residential address.</p>
                <p>If you have made a mistake when registering (for example you may have mistyped your address), or if you have moved to a new house your address will need to be updated please contact customer services by emailing support@quickremitltd.com who will be able to help. You can find their contact details on our website.</p>
                <p>Alternatively, a profile update form is available on the portal for clients to change their details and attach supporting documentation. Changes will need to be verified and approved before it can be reflected</p>
            </div>
        `,
    },
    {
        question: 'How do I change the email address on my account?',
        answer: `<div>Email changes is possible via the Profile Update form</div>`,
    },
    {
        question: 'How do I change the Mobile number on my account?',
        answer: `<div>Phone number change is possible via the Profile Update form</div>`,
    },
    {
        question: 'Can I have multiple accounts with QuickRemit?',
        answer: `<div>No, we can only permit one account per customer.</div>`,
    },
    {
        question: 'Can I have a joint account with QuickRemit?',
        answer: `<div>We do not permit joint accounts or multiple account holders at the current time. Each customer must create their own individual account.
        This is because we need to ensure we are completing necessary identity checks on every individual who uses QuickRemit services.</div>`,
    },
]